<template>
  <div class="mt-7 flex justify-stretch gap-5 sm:justify-end">
    <slot />
  </div>
</template>
